import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GetListaMenuTopo,GetListaSubMenuTopo } from '../../../actions/scopoAction';

class home extends Component {

    componentWillMount() {
       this.props.GetListaMenuTopo([{action:false,nome:"Home"}]);
       this.props.GetListaSubMenuTopo([]);
    }

    render() {
        return (
            <div className="container-bg home">
                <p>Seja bem vindo!</p>        
              <p>Você está participando do piloto do Gamifica Senai no TheoPrax. Este projeto consiste em uma estratégia de gamificação baseada em uma plataforma online. Do ponto de vista dos estudantes, a plataforma representa uma nave que viaja pelo tempo rumo a um futuro melhor. Na metáfora dessa viagem, o professor é um controlador de vôo que orienta a turma no seu percurso. Nessa versão do Gamifica Senai, você pode conversar e compartilhar vídeos e imagens com suas turmas e com as equipes de PFC01 através de uma timeline, você também pode enviar missões individuais e em equipe para os estudantes.</p>
            </div>
        );
    }
}

function mapStateToProps(state){

    return { menu : state.configReducer.menu }

}
  
export default connect(mapStateToProps,{GetListaMenuTopo,GetListaSubMenuTopo})(home);
         



// WEBPACK FOOTER //
// ./src/components/professor/home_professor/home.js